module.exports = __webpack_public_path__ + "static/media/foto4.b1e668c9.png";